document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('header-menu-drawer-panel a[href*="#"]');
  var headerMenuDrawerPanel = document.querySelector('header-menu-drawer');
  if (links.length == 0) return;

  links.forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href) return;

    var hasHash = href.indexOf('#') !== -1;
    if (!hasHash) return;

    link.addEventListener('click', function (event) {
      if (headerMenuDrawerPanel.open) {
        headerMenuDrawerPanel.hide();
      }
    });
  });
});